export default "__VITE_ASSET__BdG28mys__"